
export default () => ({
    init() {  
    },
    subscribeBackinStock(){
        
        let email = document.getElementById("subscription-email_address");
        let customeremail = email.value
        let variantId = email.getAttribute('data-backin-stock-variant-id');

        if(email == ""){
          return
        } 

        console.log(customeremail, variantId);
         variantId = variantId.toString(); // e.g., "1234567890"

                const payload = {
                "data": {
                    "type": "back-in-stock-subscription",
                    "attributes": {
                    "profile": {
                        "data": {
                            "type": "profile",
                            "attributes": {
                                "email": customeremail,
                            }
                        }
                    },
                    "channels": ["EMAIL"],
                    },
                    "relationships": {
                    "variant": {
                        "data": {
                        "type": "catalog-variant",
                        "id":  `$shopify:::$default:::${variantId}`
                        }
                    }
                    }
                }
                }
            console.log("payload", payload);
            var requestOptions = {
                method: 'POST',
                headers: {
                "Content-Type": "application/json",
                "revision":"2024-06-15"
                },
                body: JSON.stringify(payload),
            };
// ULFcWv id should be Publick API Key
            fetch("https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=ULFcWv",requestOptions)
                    .then(response => {
                    if (response.ok) {
                        document.querySelector('.backinstock-form-js').classList.add('hidden')
                        document.querySelector('.success-js').classList.remove('hidden')
                    } else {
                        console.log('error', error)
                    }
                })
                .catch(error => console.log('error', error))
                .finally(() => {
                    console.log('finally')
                });
      
        
        
    }
})